// frontend/src/hooks/useProjects.ts

import { useEffect, useState, useCallback } from 'react';
import { projectService } from '../services/project.service';
import { useAuthStore } from '../store/authStore';
import { ProjectWithStatus } from '../types/project.types';

export function useProjects() {
  const userId = useAuthStore((s) => s.session?.user.id);
  const [projects, setProjects] = useState<ProjectWithStatus[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!userId) return;
    setIsLoading(true);
    setError(null);
    try {
      const data = await projectService.listProjectsWithStatus(userId);
      setProjects(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Projeler yüklenemedi.');
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { projects, isLoading, error, reload };
}
